import { render, staticRenderFns } from "./TupleList.vue?vue&type=template&id=34c62929&scoped=true&lang=pug&"
import script from "./TupleList.vue?vue&type=script&lang=js&"
export * from "./TupleList.vue?vue&type=script&lang=js&"
import style0 from "./TupleList.vue?vue&type=style&index=0&id=34c62929&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c62929",
  null
  
)

export default component.exports